import React from "react";

interface DesktopModePromptProps {
  message?: string;
  onAccept: () => void;
  onGoBack: () => void;
}

const DesktopModePrompt: React.FC<DesktopModePromptProps> = ({
  message = "This page is best viewed in desktop mode. Switch to desktop view for the best experience.",
  onAccept,
  onGoBack,
}) => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#1C2C3A] to-[#1E4F52] flex items-center justify-center p-4">
      <div className="bg-[#161F28] border border-[#374B5E] rounded-xl p-6 max-w-sm w-full text-center space-y-4">
        <div className="w-12 h-12 mx-auto bg-[#2E4051] rounded-full flex items-center justify-center">
          <svg
            className="w-6 h-6 text-[#008564]"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
            />
          </svg>
        </div>
        <h3 className="text-white text-lg font-semibold">
          Desktop View Recommended
        </h3>
        <p className="text-[#889DB2] text-sm">{message}</p>
        <div className="flex gap-3 pt-2">
          <button
            onClick={onGoBack}
            className="flex-1 px-4 py-2 bg-[#2E4051] text-white rounded-lg hover:bg-[#3a5063] transition-colors text-sm"
          >
            Go Back
          </button>
          <button
            onClick={onAccept}
            className="flex-1 px-4 py-2 bg-[#008564] text-white rounded-lg hover:bg-[#006d52] transition-colors text-sm font-medium"
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default DesktopModePrompt;
